import { render } from "./AddJobVacancy.vue?vue&type=template&id=4b8d528e&scoped=true"
import script from "./AddJobVacancy.vue?vue&type=script&lang=js"
export * from "./AddJobVacancy.vue?vue&type=script&lang=js"

import "./vacancy.scss?vue&type=style&index=0&id=4b8d528e&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8d528e"]])

export default __exports__